import { render, staticRenderFns } from "./MailParserInfoEdit.vue?vue&type=template&id=2264acc2&scoped=true&"
import script from "./MailParserInfoEdit.vue?vue&type=script&lang=js&"
export * from "./MailParserInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./MailParserInfoEdit.vue?vue&type=style&index=0&id=2264acc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264acc2",
  null
  
)

export default component.exports